import FJNavBar from '../../../common/components/FJNavBar/FJNavBar.jsx';
import { AI_COMMUNITY_TAB_LIST } from '../../../config/dataConfig/FJCommunityData.js';
import PropTypes from 'prop-types';
import styles from './FJCommunityLeft.module.less';
import FJTextWithEllipsis from '../../../common/components/FJTextWithEllipsis/FJTextWithEllipsis.jsx';
import FJLocalStore from '../../../store/FJLocalStore.js';
import FJFlexClipIcon from '../../../assets/svg/community/flexclip-video-editor.svg?react';
const FJCommunityLeft = props => {
    const { navBarTab, onChangeTabIndex, onFlexClipClick } = props;
    return (
        <div className={styles.container}>
            <FJNavBar
                selectTab={navBarTab}
                onChangeTab={onChangeTabIndex}
                tabList={AI_COMMUNITY_TAB_LIST}
                isCommunityNav={true}
            />
            <div className={styles.flexclip_button} onClick={onFlexClipClick}>
                <FJFlexClipIcon className={styles.icon} />
                <FJTextWithEllipsis className={styles.name} text={FJLocalStore._('flexclip-video-editor')} />
            </div>
        </div>
    );
};

FJCommunityLeft.propTypes = {
    navBarTab: PropTypes.string.isRequired,
    onChangeTabIndex: PropTypes.func.isRequired,
    onFlexClipClick: PropTypes.func.isRequired,
};

export default FJCommunityLeft;
